/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';
declare var Dropzone:any;

class DropzoneDirective {

    public restrict;
    public scope;

    constructor() {
        this.restrict = 'A';
        this.scope = false;
    }

    public link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs) => {
        var config, dropzone;

        config = scope[attrs.dropzone];

        // create a Dropzone for the element with the given options
        dropzone = new Dropzone(element[0], {});

        // bind the given event handlers
        angular.forEach(config.eventHandlers, function (handler, event) {
            dropzone.on(event, handler);
        });
    };

    public static DirectiveFn(): any {
        return new DropzoneDirective();
    }

}

angular.module('beneple.global')
    .directive('dropzone', DropzoneDirective.DirectiveFn);




// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/dropzone.directive.ts